import { render, staticRenderFns } from "./HistoryMovieLists.vue?vue&type=template&id=2c8fba11&scoped=true&"
import script from "./HistoryMovieLists.vue?vue&type=script&lang=js&"
export * from "./HistoryMovieLists.vue?vue&type=script&lang=js&"
import style0 from "./HistoryMovieLists.vue?vue&type=style&index=0&id=2c8fba11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8fba11",
  null
  
)

export default component.exports